import React from 'react'
import { UseFormRegister, UseFormHandleSubmit } from 'react-hook-form'
import FlatButton from '../../../components/buttons/flat_button'
import { TextareaInput } from '../../../components/form/inputs/TextareaInput'

export type AiInstructionFormData = {
  aiInstruction: string
}

interface AiRegenerateSectionProps {
  register: UseFormRegister<AiInstructionFormData>
  handleSubmit: UseFormHandleSubmit<AiInstructionFormData>
  aiInstruction: string
  isUpdating: boolean
  onSubmit: (data: AiInstructionFormData) => Promise<void>
  placeholder?: string
}

export const AiRegenerateSection: React.FC<AiRegenerateSectionProps> = ({
  register,
  handleSubmit,
  aiInstruction,
  isUpdating,
  onSubmit,
  placeholder = 'AI再生成への指示を入力してください',
}) => {
  return (
    <>
      <p className="mb-2">
        このスライドのみの再生成をAIに指示する場合は、下記にご入力ください
      </p>
      <TextareaInput
        register={register('aiInstruction')}
        placeholder={placeholder}
        rows={3}
        className="mb-3"
      />
      <FlatButton
        onClick={handleSubmit(onSubmit)}
        disabled={!aiInstruction.trim() || isUpdating}
      >
        AIに指示する
      </FlatButton>
    </>
  )
}
